import { LitElement, html, css } from 'lit';
import { customElement, property} from 'lit/decorators.js';
import { JobindsatsElement } from '../../core/jobindsats-element';
@customElement('maaling-dropdown-element')
export class MaalingDropdownElement extends JobindsatsElement(LitElement) {
    static styles = css`
        .dropdown{
            background-color: transparent;
            border: none;
            padding: 0 1em 0 0;
            outline: none;
            font-family: inherit;
            font-size: inherit;
         }
        .category-select{
            text-align: right;
            padding-bottom: 15px;
        }
    `;

    @property({
        attribute: 'dropdownOptions',
    })
    dropdownOptions: { key: string; name: string }[] = [];


    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    render() {
        if (this.dropdownOptions.length > 0) {
            return html`
            <div class="category-select">
                <label for="dropdown">Sortering: </label>
                  <select @change=${(e: Event) => this.itemSelected((e.target as HTMLSelectElement).value)} class="dropdown">
                    ${this.dropdownOptions.map(option => html`
                        <option value=${option.key}>${option.name}</option>`)}
                  </select>
            </div>
            `;
        } else {
            return html``;
        }
    }

    itemSelected(optionKey: string) {
        const itemSelectedEvent = new CustomEvent("item-selected",
            {
                detail: {
                    key: optionKey,
                },
                composed: true,
                bubbles: true,
            });
        this.dispatchEvent(itemSelectedEvent);
    }
}